import React from 'react';
import { useTranslations } from 'use-intl';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { Info } from 'react-feather';
import { BRAND_COLORS } from '@/UIlibrary/globalTheme';

interface AIRatingProps {
	aiRating?: string | null;
}

const AIRating: React.FC<AIRatingProps> = ({ aiRating }) => {
	const t = useTranslations('CreditBureau');

	if (!aiRating) return null;

	const formatPercentage = (value: string): string => {
		const numValue = parseFloat(value);
		if (isNaN(numValue)) return value;
		const percentage = numValue * 100;
		return percentage.toFixed(2);
	};

	const displayValue = formatPercentage(aiRating);

	return (
		<div
			className="flex flex-col p-4 rounded-lg text-center overflow-y-scroll border "
			style={{
				backgroundColor: '#F5F5F5',
				maxHeight: '300px'
			}}
		>
			<Typography weight="semibold" size="lg">
				{t('RiskScore')}
			</Typography>
			<div className="my-2">
				<Typography weight="semibold" size="xl">
					{displayValue}%
				</Typography>
			</div>
			<div className="flex items-center gap-2">
				<Info color={BRAND_COLORS.brand600} size={16} className="cursor-pointer" />
				<Typography size="xs" color="gray">
					{t('CreditBureauDefaultScoreDescription')}
				</Typography>
			</div>
		</div>
	);
};

export default AIRating;
